var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialReportTotalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.5V17.5C22 20.5 20 22.5 17 22.5H7C4 22.5 2 20.5 2 17.5V12.5C2 9.78 3.64 7.88 6.19 7.56C6.45 7.52 6.72 7.5 7 7.5H17C17.26 7.5 17.51 7.50999 17.75 7.54999C20.33 7.84999 22 9.76 22 12.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7514 7.55C17.5114 7.51 17.2614 7.50001 17.0014 7.50001H7.00141C6.72141 7.50001 6.45141 7.52001 6.19141 7.56001C6.33141 7.28001 6.53141 7.02001 6.77141 6.78001L10.0214 3.52C11.3914 2.16 13.6114 2.16 14.9814 3.52L16.7314 5.29002C17.3714 5.92002 17.7114 6.72 17.7514 7.55Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H19C17.9 13 17 13.9 17 15C17 16.1 17.9 17 19 17H22",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialReportTotalIcon);
export default __webpack_public_path__ + "static/media/financial_report_total_icon.3cdef970d063b1d6ee304adacd48952c.svg";
export { ForwardRef as ReactComponent };